<div class="flex flex-col sm:flex-row gap-2 justify-center items-center">
    <div class="flex flex-col min-w-[300px] pt-8 pb-8 bg-ponder-xlight rounded shadow-md p-2">
        <div class="flex flex-col gap-2 text-slate-50 p-4">
            <div class="font-bold font-title text-center text-foil text-lg">
                Unauthorized
            </div>
            @if (!authSession) {
                <div class="text-sm">
                    Please login or create an account to view this page.
                </div>
                <div class="pt-4"></div>
                <a href="/login"  class="p-1 bg-faded-10 rounded shadow-sm hover:text-white hover:bg-faded-20 text-center">
                    Login / Sign Up
                </a>
                <a href="/" class="text-sm text-center text-faded-50 hover:text-ponder-bright">
                    or return home
                </a>
            } @else {
                <div class="text-sm">
                    This page is visible only to the associated user.
                </div>
            }
        </div>
    </div>
</div>